function initCaratHeader(root) {
  const scope = root || document;

  initCaratAnnouncement(scope);
  initCaratMenu(scope);
  initCaratSearch(scope);
}

function initCaratAnnouncement(scope) {
  const announcementBars = scope.querySelectorAll('[data-carat-announcement]');

  announcementBars.forEach(function (bar) {
    if (bar.dataset.caratInit === 'true') return;
    bar.dataset.caratInit = 'true';

    const slides = bar.querySelectorAll('.carat-announcement__message');
    const interval = parseInt(bar.dataset.rotateSpeed || '3000', 10);

    if (!slides.length) return;

    let index = 0;
    slides[0].classList.add('is-active');

    if (slides.length > 1) {
      window.setInterval(function () {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, interval);
    }
  });
}

function initCaratMenu(scope) {
  const toggles = scope.querySelectorAll('[data-carat-menu-toggle]');

  toggles.forEach(function (toggle) {
    if (toggle.dataset.caratBound === 'true') return;
    toggle.dataset.caratBound = 'true';

    const targetId = toggle.getAttribute('aria-controls');
    const target = document.getElementById(targetId);
    const closeButton = target ? target.querySelector('[data-carat-menu-close]') : null;

    if (!target) return;

    function openDrawer() {
      closeAllCaratSearchDrawers();

      toggle.setAttribute('aria-expanded', 'true');
      target.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      toggle.setAttribute('aria-expanded', 'false');
      target.hidden = true;

      if (!document.querySelector('.cb-search-drawer.is-open')) {
        document.body.style.overflow = '';
      }
    }

    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeButton && closeButton.dataset.caratBound !== 'true') {
      closeButton.dataset.caratBound = 'true';
      closeButton.addEventListener('click', closeDrawer);
    }
  });
}

function closeAllCaratMenus() {
  const openToggles = document.querySelectorAll('[data-carat-menu-toggle][aria-expanded="true"]');

  openToggles.forEach(function (toggle) {
    const targetId = toggle.getAttribute('aria-controls');
    const target = document.getElementById(targetId);

    toggle.setAttribute('aria-expanded', 'false');

    if (target) {
      target.hidden = true;
    }
  });
}

function closeAllCaratSearchDrawers() {
  document.querySelectorAll('[data-carat-search-drawer]').forEach(function (drawer) {
    if (typeof drawer.caratClose === 'function') {
      drawer.caratClose(false);
    }
  });
}

function initCaratSearch(scope) {
  const drawers = scope.querySelectorAll('[data-carat-search-drawer]');

  drawers.forEach(function (drawer) {
    if (drawer.dataset.caratSearchBound === 'true') return;
    drawer.dataset.caratSearchBound = 'true';

    const drawerId = drawer.id;
    const triggers = document.querySelectorAll(
      '[data-carat-search-open][aria-controls="' + drawerId + '"]'
    );
    const closeButtons = drawer.querySelectorAll('[data-carat-search-close]');
    const panel = drawer.querySelector('.cb-search-drawer__panel');
    const input = drawer.querySelector('input[type="search"]');
    const resetButton = drawer.querySelector('button[type="reset"]');
    const defaultState = drawer.querySelector('[data-carat-search-default]');
    const predictiveSearch = drawer.querySelector('predictive-search');

    let lastFocusedTrigger = null;
    let closeTimer = null;

    if (!input || !panel) return;

    function updateEmptyState() {
      const hasQuery = input.value.trim().length > 0;

      drawer.classList.toggle('has-query', hasQuery);

      if (defaultState) {
        defaultState.hidden = hasQuery;
      }

      if (resetButton) {
        resetButton.classList.toggle('hidden', !hasQuery);
      }
    }

    function openDrawer(trigger) {
      closeAllCaratMenus();
      closeAllCaratSearchDrawers();

      if (closeTimer) {
        window.clearTimeout(closeTimer);
      }

      lastFocusedTrigger = trigger || null;

      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');

      triggers.forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });

      document.body.classList.add('carat-search-open');
      document.body.style.overflow = 'hidden';

      updateEmptyState();

      window.requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        input.focus();

        if (typeof trapFocus === 'function') {
          trapFocus(panel, input);
        }
      });
    }

    function closeDrawer(returnFocus) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      triggers.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      if (predictiveSearch && typeof predictiveSearch.close === 'function') {
        predictiveSearch.close(true);
      } else {
        input.value = '';
      }

      updateEmptyState();

      document.body.classList.remove('carat-search-open');

      if (!document.querySelector('[data-carat-menu-toggle][aria-expanded="true"]')) {
        document.body.style.overflow = '';
      }

      if (typeof removeTrapFocus === 'function') {
        removeTrapFocus(returnFocus && lastFocusedTrigger ? lastFocusedTrigger : null);
      } else if (returnFocus && lastFocusedTrigger) {
        lastFocusedTrigger.focus();
      }

      closeTimer = window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, 260);
    }

    drawer.caratClose = closeDrawer;

    triggers.forEach(function (trigger) {
      if (trigger.dataset.caratSearchTriggerBound === 'true') return;
      trigger.dataset.caratSearchTriggerBound = 'true';

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openDrawer(trigger);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        closeDrawer(true);
      });
    });

    input.addEventListener('input', function () {
      updateEmptyState();
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        window.setTimeout(function () {
          updateEmptyState();
          input.focus();
        }, 0);
      });
    }

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer(true);
      }
    });

    updateEmptyState();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initCaratHeader(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initCaratHeader(event.target);
});